import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, Link } from 'react-router-dom';
import { engineeringConsultancy, digitalServices, dedicatedResourcesServices } from './../Data/services';
import { serviceDetailsData } from './../Data/serviceDetails'; // <-- NEW IMPORT
import Breadcrumb from '../Components/Breadcrumb';

function ServiceDetailPage() {
    const { category, serviceSlug } = useParams();

    let services = [];

    if (category === "engineering-consultancy") {
        services = engineeringConsultancy;
    } else if (category === "digital-services") {
        services = digitalServices;
    } else if (category === "dedicated-resources-services") {
        services = dedicatedResourcesServices;
    }

    const service = services.find(s => s.link === serviceSlug);
    const serviceDetail = serviceDetailsData[serviceSlug]; // <-- Fetch dynamic content

    const breadcrumbLinks = [
        { label: 'Home', url: '/' },
        { label: 'Services', url: '/services' },
        { label: category.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()), url: `/services/${category}` },
        { label: service ? service.title : 'Service Not Found' }
    ];

    if (!service || !serviceDetail) {
        return (
            <div className="service-area pd-top-112">
                <div className="container text-center">
                    <Breadcrumb pageTitle="Service Not Found" breadcrumbLinks={breadcrumbLinks} />
                    <h2>Oops! Service not found.</h2>
                    <Link to="/services" className="btn btn-primary mt-3">Back to Services</Link>
                </div>
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>{serviceDetail.metaTitle}</title>
                <meta name="description" content={serviceDetail.metaDescription} />
            </Helmet>
            <Breadcrumb pageTitle={serviceDetail.title} breadcrumbLinks={breadcrumbLinks} />
            <div className="work-processing-area pd-default-120 pb-60">
                <div className="container">
                    <div className="row justify-content-center single-work-processing">
                        <div className="col-12 text-center mb-3">
                            <div className="section-title">
                                <h2 className="title"><span>{serviceDetail.title}</span></h2>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-5 order-lg-12">
                            <div className="thumb swp-right-thumb">
                                <img src={service.icon} alt={service.title} className='w-100' />
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-6 order-lg-1 desktop-center-item">
                            <div className="work-processing-details">
                                <div className="section-title style-four">
                                    {serviceDetail.description && <p>{serviceDetail.description}</p>}
                                    {serviceDetail.description2 && <p>{serviceDetail.description2}</p>}
                                    {serviceDetail.description3 && <p>{serviceDetail.description3}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {serviceDetail.services && serviceDetail.services.length > 0 && (
                <div className="service-area pd-top-40">
                    <div className="container">
                        <div className="row justify-content-center pb-4">
                            <div className="col-xl-7 col-lg-10">
                                <div className="section-title text-center">
                                    <h2 className="title wow animated fadeInUp" data-wow-duration="0.6s" data-wow-delay="0.1s">Delivering Smart, Scalable Solutions for Modern Businesses</h2>
                                    <p className="wow animated fadeInUp text-center" data-wow-duration="0.6s" data-wow-delay="0.2s">Whether you're building infrastructure, launching digital platforms, or optimizing operations, our services are designed to align with your goals. We bring technical expertise, strategic insight, and hands-on support to help you move faster, work smarter, and grow stronger.</p>
                                </div>
                            </div>
                        </div>
                        <div className="sba-featute-area pd-top-50 px-5">
                            <div className="container">
                                <div className="row custom-gutters-16 justify-content-center">
                                    {serviceDetail.services && serviceDetail.services.length > 0 && (
                                        <>
                                            {Array.from({ length: Math.ceil(serviceDetail.services.length / 2) }).map((_, columnIndex) => (
                                                <div key={columnIndex} className={`col-xl-5 col-sm-6 ${columnIndex === 1 ? 'mg-top-80' : ''}`}>
                                                    <div className={`single-feature-${columnIndex % 2 === 0 ? 'left' : 'right'}`}>
                                                        {serviceDetail.services.slice(columnIndex * 2, columnIndex * 2 + 2).map((service, i) => (
                                                            <div key={i} className={`single-feature ${i === 0 ? '' : 'border-radius-' + (columnIndex * 2 + i + 1)}`}>
                                                                <div className={`media ${i === 0 ? '' : 'border-radius-' + (columnIndex * 2 + i + 1)}`} style={{ backgroundImage: `url(${service.bgImg})` }}>
                                                                    <div className="media-body">
                                                                        <h6>{service.title}</h6>
                                                                        <p >{service.description}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                    {/* {serviceDetail.services && serviceDetail.services.length > 0 && (
                                    <>
                                        {serviceDetail.services.map((service, i) => (
                                            <div className={`col-xl-4 col-sm-6`}>
                                                <div className={`single-feature`}>
                                                    <div key={i} className={`single-feature`}>
                                                        <div className={`media `} style={{ backgroundImage: `url(${service.bgImg})` }}>
                                                            <div className="media-body">
                                                                <h6>{service.title}</h6>
                                                                <p>{service.description}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )} */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="sbbs-pricing-area mg-top-100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-9 col-lg-4 col-sm-6">
                            <div className="section-title text-center mb-0">
                                <h2 className="title">Why Choose Us For {serviceDetail.title}</h2>
                            </div>
                            <div className="single-pricing feature-box text-start">
                                <ul className='offset-lg-1'>
                                    {serviceDetail.whyChooseUs.points.map((point, idx) => (
                                        <li key={idx}>{point}</li>
                                    ))}
                                </ul>
                                <div className="text-center">
                                    <Link className="btn btn-white btn-rounded" to="/contact">Get Started</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ServiceDetailPage;
